export const SPRITE_LOADER_PROGRESS = 'spriteLoader/SPRITE_LOADER_PROGRESS';